import type { ReactElement } from 'react';
import { Helmet } from 'react-helmet-async';

type Props = {
    /** The page's own part of the tab title, e.g. "Home" or the customer name. */
    title: string;
};

/**
 * Sets the browser tab title to "{title} | Plato". Helmet's `titleTemplate` does
 * not carry across instances under React 19, so the suffix is added here.
 */
export function PageTitle({ title }: Props): ReactElement {
    return (
        <Helmet>
            <title>{`${title} | Plato`}</title>
        </Helmet>
    );
}
